import React, { useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Img } from '../../../components';
import { useToast } from '../../../hooks/toast';
import { useAuth } from '../../../hooks/useAuth';
import { RoutesPaths } from '../../../routes';
import { Container, Wrapper, FormContent } from '../Login/style';
import UnicredLogo from './../../../assets/logos/logo_uni_horizontal_verde.svg';

export const LoginExterno: React.FC = () => {
  const [loginRequestLoading, setLoginRequestLoading] = useState(false);
  const history = useHistory();
  const { addToast } = useToast();
  const { signInExterno } = useAuth();

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);

  const session_id = urlParams.get('session_id') as any;
  const s_temp = urlParams.get('s_temp') as any;

  const handleSubmit = useCallback(async () => {
    try {
      if (loginRequestLoading) {
        return;
      }

      setLoginRequestLoading(true);
      await signInExterno({ usuario: session_id, senha: s_temp });

      setLoginRequestLoading(false);
      history.push(RoutesPaths.home);
    } catch (error) {
      setLoginRequestLoading(false);

      addToast({
        type: 'error',
        title: 'Login Expirado',
        description:
          'O seu login expirou, por favor efetue login novamente no botão abaixo',
        time: 6000,
      });
    }
  }, [signInExterno, addToast]);

  useEffect(() => {
    handleSubmit();
  }, []);

  return (
    <Container>
      <Wrapper>
        <FormContent>
          <figure>
            <Img src={UnicredLogo} alt="Logo Unicred" />
          </figure>
          <div>
            <p style={{ textAlign: 'center' }}>
              Aguarde enquanto estamos redirecionado você.
            </p>
          </div>
        </FormContent>
      </Wrapper>
    </Container>
  );
};
